<template>
  <div id="page-wrap" v-if="loggedIn&&user">
    <PageHeader :activeLink="'home'"></PageHeader>
    <div class="container content-wrap">
      <div class="row">
        <div class="hidden-xs col-md-10 col-md-offset-1">
          <QuickLinks></QuickLinks>
        </div>
        <CreditPaused v-if="creditPaused" :creditPauseMsg="creditPauseMsg"></CreditPaused>
        <BalanceIndicator v-else></BalanceIndicator>

        <section class="col-md-6 content-section col-xs-12">
          <TransactionList v-if="showTransactionList && user.profile_complete" :unsettled="true"></TransactionList>
          <div class="col-md-12 profile-incomplete-msg" v-if="!user.profile_complete">
            <a :href="user.profile_complete_link">
              <Toast
                :classNames="'toast-bordered text-center toast-warning'"
                :text="user.limitReviewMessage"
              ></Toast>
            </a>
          </div>
        </section>
      </div>
      <MobileNav :activeLink="'home'" class="visible-xs"></MobileNav>
    </div>
    <!-- invite popup -->
    <modal v-if="showModal">
      <div class="invitePopup" slot="body">
        <div class="popup-content">
          <span class="new-tag">new</span>
          <button type="button" class="close" id="closepopup" @click="closeModal()">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 40 40"
              width="30"
              height="30"
              xml:space="preserve"
            >
              <path
                class="st0"
                fill="#000"
                d="M8.7,7.6c-0.4-0.4-1-0.4-1.4,0C6.9,8,6.9,8.6,7.3,9l11,11l-11,11c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0 l11-11l11,11c0.4,0.4,1,0.4,1.4,0c0.4-0.4,0.4-1,0-1.4l-11-11L32,9c0.4-0.4,0.4-1,0-1.4c-0.4-0.4-1-0.4-1.4,0l-11,11L8.7,7.6z"
              />
            </svg>
          </button>

          <h3 class="text-center">Invite &amp; Get Higher Limit</h3>
          <p class="text-center">On every successful signup</p>
          <div class="offers">
            <ul>
              <li>
                <p>You Get</p>
                <span class="offer-img">
                  <img src="/static/images/svgs/img-credit-limit.svg" />
                </span>
                <h4>+250</h4>
                <p>Credit Limit</p>
              </li>
              <li>
                <p>Your Friends Get</p>
                <span class="offer-img">
                  <img src="/static/images/svgs/img-reward-points.svg" />
                </span>
                <h4>+50</h4>
                <p>Reward Points</p>
              </li>
            </ul>
          </div>
          <span class="btn-invite">
            <router-link
              id="btnInvite"
              href="javascript:void(0)"
              :to="{name:'InviteAndUpgrade'}"
              @click.native="changePopupStatus()"
            >Invite Now</router-link>
          </span>
        </div>
      </div>
    </modal>
    <!-- invire popup -->
  </div>
</template>

<script>
import Vue from "vue";
import PageHeader from "./PageHeader/index";
import BalanceIndicator from "./BalanceIndicator/index";
import CreditPaused from "./CreditPaused/index";
import MobileNav from "./MobileNav/index";
import TransactionList from "./TransactionList/index";
import QuickLinks from "./QuickLinks/index";
import Toast from "./Toast/index";
import Modal from "./Modal";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "Home",
  data() {
    return {
      showTransactionList: false,
      completeProfileLink: undefined,
      showModal: false
    };
  },
  computed: {
    ...mapGetters([
      "creditPauseMsg",
      "creditPaused",
      "activeTransaction",
      "loggedIn",
      "user"
    ])
  },
  components: {
    PageHeader,
    BalanceIndicator,
    CreditPaused,
    MobileNav,
    TransactionList,
    QuickLinks,
    Toast,
    Modal
  },
  mounted() {
    if (process.env.NODE_ENV == "production") {
      this.completeProfileLink = "https://epaylater.in/profile";
    } else if (process.env.NODE_ENV == "development") {
      this.completeProfileLink = "https://staging.epaylater.in/profile";
    }
    this.$store.dispatch("loadHome").then(() => {
      this.showTransactionList = true;
    });
    localStorage.removeItem("activeTxn");
    if (
      this.user &&
      this.user.features &&
      this.user.features.referral.enabled
    ) {
      this.chkPopupStatus();
    }
  },
  created() {
    switch (this.$route.params.state) {
      case "credit-paused":
        this.creditPaused = true;
        break;
      case "upcoming-payment":
        this.upcomingPayment = true;
        break;
      case "payment-alert":
        this.paymentAlert = true;
        break;
      case "no-pending-dues":
        this.noPendingDues = true;
        break;
      case "credit-used":
        this.creditUsed = true;
        break;
    }
  },
  methods: {
    openModal() {
      this.showModal = true;
      localStorage.setItem("popupStatus", "displayed");
      var body = document.body;
      body.style.position = "fixed";
      body.style.width = "100%";
    },
    closeModal() {
      this.showModal = false;
      localStorage.setItem("popupStatus", "seen");
      var body = document.body;
      body.style.position = "initial";
      body.style.width = "auto";
    },
    chkPopupStatus() {
      let modalStatus = localStorage.getItem("popupStatus");
      if (modalStatus !== "seen" && modalStatus !== "displayed") {
        this.openModal();
      }
    },
    changePopupStatus() {
      localStorage.setItem("popupStatus", "seen");
      var body = document.body;
      body.style.position = "initial";
      body.style.width = "auto";
    }
  }
};
</script>
<style scoped lang="scss">
@import "../assets/sass/variables";
.popup-content {
  padding: 25px 10px;
  .close {
    margin-top: -5px;
    @media screen and (max-width: $md) {
      position: absolute;
      right: 10px;
      top: 20px;
      opacity: 1;
    }
    svg {
      @media screen and (max-width: $md) {
        width: 22px;
        height: 22px;
      }
    }
  }
  .new-tag {
    display: inline-block;
    background: #6ed39e;
    color: var(--white);
    text-transform: uppercase;
    font-size: 14px;
    padding: 0 14px;
    border-radius: 65px;
    line-height: 25px;
    @media screen and (max-width: $md) {
      font-size: 12px;
      line-height: initial;
      /* padding: 4px 14px 1px; */
      padding: 0 14px;
      height: 22px;
      line-height: 24px;
    }
  }
  h3 {
    margin: 4px 0 0;
    color: #4b5566;
    @media screen and (max-width: $md) {
      margin: 15px 0 5px;
      font-size: 18px;
    }
  }
  h4 {
    margin: 24px 0 0;
  }
  p {
    font-size: 14px;
    color: #718099;
    @media screen and (max-width: $md) {
      font-size: 12px;
    }
  }
  .offers {
    ul {
      margin: 50px 0;
      padding: 0;
      @media screen and (max-width: $md) {
        margin: 35px 0;
      }
      li {
        list-style: none;
        text-align: center;
        width: 49%;
        display: inline-block;
        border-right: solid 1px rgba(75, 85, 102, 0.16);
        &:last-child {
          border-right: none;
        }
        .offer-img {
          height: 64px;
          display: inline-block;
          line-height: 55px;
          @media screen and (max-width: $md) {
            height: 55px;
          }
          img {
            height: 100%;
            width: auto;
          }
        }
      }
    }
  }
  .btn-invite {
    a {
      color: var(--white);
      background: #377cfd;
      font-size: 16px;
      display: block;
      text-align: center;
      border-radius: 40px;
      line-height: 50px;
    }
  }

  @media screen and (max-width: $md) {
    text-align: center;
  }
}
@media screen and (min-width: $md) {
  .profile-incomplete-msg,
  .profile-incomplete-msg .toast {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 80%;
    max-height: 74px;
    margin: auto;

    // -webkit-transform:translate(-50%, -50%);
    // -moz-transform:translate(-50%, -50%);
    // -o-transform:translate(-50%, -50%);
    // -ms-transform:translate(-50%, -50%);
    // transform:translate(-50%, -50%);
  }
}

.content-section {
  background-color: var(--white);
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin-top: -10px;
  overflow: hidden;
  padding: 0;
  @media screen and (min-width: $md) {
    border-radius: 10px;
    margin-top: 0;
    min-height: 650px;
  }
  @media screen and (min-width: $md) {
    border-radius: 0px;
    background: white;
  }
  @media screen and (max-width: $md) {
    margin-top: 0;
    margin-bottom: 40px;
  }

  header {
    border-top-right-radius: 6px;
    border-top-left-radius: 6px;
    margin-bottom: 0px;
    background-color: var(--white);
    border-bottom: 1px solid #f1f2f3;

    @media screen and (max-width: $md) {
      border-bottom: 0px;
      border-radius: 0px;
      background: transparent;
    }
    .counter {
      min-width: 24px;
      height: 24px;
      text-align: center;
      display: inline-block;
      background-color: #fd7f5b;
      color: var(--white);
      border-radius: 12px;
      padding: 0 7px;
      line-height: 24px;
    }

    h1 {
      font-size: 14px;
      display: inline-block;
      line-height: 80px;
      margin: 0 0 0 10px;
      letter-spacing: -0.2px;
      color: #718099;
    }

    .blue-btn-lg {
      width: 110px;
      height: 48px;
      border-radius: 50px;
      background-color: #377cfd;
      float: right;
      border: none;
      font-size: 16px;
      color: var(--white);
      margin: 16px 0;
    }
  }

  ul.vendor-list {
    li {
      min-height: 80px;
      background-color: var(--white);
      border-bottom: 1px solid #f1f2f3;

      .vendor-icon {
        margin: 16px 0;
      }

      .vendor-detail {
        margin: 22px 0;
        h2,
        p {
          margin: 0;
        }

        .site-name {
          font-size: 16px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: -0.3px;
          color: #4b5566;
        }
        .date {
          font-family: Overpass;
          font-size: 12px;
          font-style: normal;
          font-stretch: normal;
          line-height: normal;
          letter-spacing: normal;
          color: #718099;
          font-weight: normal;
          margin-left: 0px;
          strong {
            color: #4b5566;

            font-weight: 600;
          }
        }
      }
      .vendor-bill {
        text-align: right;
        font-size: 16px;
        color: #4b5566;
      }

      &.credit-paused,
      &.upcoming-payment,
      &.transaction-overdue {
        background-color: rgba(244, 92, 95, 0.03);
        .date,
        .date strong,
        .vendor-bill {
          color: #f45c5f;
        }
      }
    }
  }
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->



// WEBPACK FOOTER //
// src/components/Home.vue